import { Observable } from 'rxjs';

export interface SystemParams {
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
}

export interface SystemForm {
    id?: number;
    name: string;
    description?: string;
    status?: string;
    created_at?: string;
    updated_at?: string;
}

export interface ApiResponse {
    success: boolean;
    message: any;
}

export abstract class System {
    //   abstract getList(params: SystemParams): Observable<ApiResponse>;
    // abstract save(param: SystemForm): Observable<ApiResponse>;
    abstract update(param: any): Observable<ApiResponse>;
    //   abstract delete(id: number): Observable<ApiResponse>;
    //   abstract getById(id: number): Observable<ApiResponse>;
} 